var _defs, _circle, _circle2, _ellipse, _circle3, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProfit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 282 282",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 141,
    cy: 141,
    r: 140,
    stroke: "#F80",
    strokeWidth: 1.818
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 141.001,
    cy: 215.545,
    r: 65.454,
    stroke: "#D6D6D6",
    strokeWidth: 1.818,
    strokeDasharray: "1.82 1.82"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 141.001,
    cy: 189.182,
    rx: 92.727,
    ry: 91.818,
    stroke: "#D6D6D6",
    strokeWidth: 1.818,
    strokeDasharray: "1.82 1.82"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.998,
    cy: 162.818,
    r: 118.182,
    stroke: "#D6D6D6",
    strokeWidth: 1.818,
    strokeDasharray: "1.82 1.82"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M146.453 131.909l-5.454-5.454-5.455 5.454M146.453 73.727l-5.454-5.454-5.455 5.454M146.453 26.455L140.999 21l-5.455 5.455",
    stroke: "#F80",
    strokeWidth: 1.818,
    strokeMiterlimit: 2.613
  })));
}

var MemoSvgProfit = /*#__PURE__*/React.memo(SvgProfit);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgyIiBoZWlnaHQ9IjI4MiIgdmlld0JveD0iMCAwIDI4MiAyODIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxjaXJjbGUgY3g9IjE0MSIgY3k9IjE0MSIgcj0iMTQwIiBzdHJva2U9IiNGRjg4MDAiIHN0cm9rZS13aWR0aD0iMS44MTgxOCIvPgo8Y2lyY2xlIGN4PSIxNDEuMDAxIiBjeT0iMjE1LjU0NSIgcj0iNjUuNDU0NSIgc3Ryb2tlPSIjRDZENkQ2IiBzdHJva2Utd2lkdGg9IjEuODE4MTgiIHN0cm9rZS1kYXNoYXJyYXk9IjEuODIgMS44MiIvPgo8ZWxsaXBzZSBjeD0iMTQxLjAwMSIgY3k9IjE4OS4xODIiIHJ4PSI5Mi43MjczIiByeT0iOTEuODE4MiIgc3Ryb2tlPSIjRDZENkQ2IiBzdHJva2Utd2lkdGg9IjEuODE4MTgiIHN0cm9rZS1kYXNoYXJyYXk9IjEuODIgMS44MiIvPgo8Y2lyY2xlIGN4PSIxNDAuOTk4IiBjeT0iMTYyLjgxOCIgcj0iMTE4LjE4MiIgc3Ryb2tlPSIjRDZENkQ2IiBzdHJva2Utd2lkdGg9IjEuODE4MTgiIHN0cm9rZS1kYXNoYXJyYXk9IjEuODIgMS44MiIvPgo8cGF0aCBkPSJNMTQ2LjQ1MyAxMzEuOTA5TDE0MC45OTkgMTI2LjQ1NUwxMzUuNTQ0IDEzMS45MDkiIHN0cm9rZT0iI0ZGODgwMCIgc3Ryb2tlLXdpZHRoPSIxLjgxODE4IiBzdHJva2UtbWl0ZXJsaW1pdD0iMi42MTMxMyIvPgo8cGF0aCBkPSJNMTQ2LjQ1MyA3My43MjczTDE0MC45OTkgNjguMjcyN0wxMzUuNTQ0IDczLjcyNzMiIHN0cm9rZT0iI0ZGODgwMCIgc3Ryb2tlLXdpZHRoPSIxLjgxODE4IiBzdHJva2UtbWl0ZXJsaW1pdD0iMi42MTMxMyIvPgo8cGF0aCBkPSJNMTQ2LjQ1MyAyNi40NTQ2TDE0MC45OTkgMjFMMTM1LjU0NCAyNi40NTQ2IiBzdHJva2U9IiNGRjg4MDAiIHN0cm9rZS13aWR0aD0iMS44MTgxOCIgc3Ryb2tlLW1pdGVybGltaXQ9IjIuNjEzMTMiLz4KPC9zdmc+Cg==";
export { MemoSvgProfit as ReactComponent };